import { createAsyncThunk } from "@reduxjs/toolkit";
import { CommonAxiosResponse, RootState, thunkResponseHandler } from "common";
import { pickBy } from "lodash";
import { UserRmaApi } from "./api";

import { GetUserRMAPayload, GetUserRmaResponse } from "./types";

export const getUserRmaDetailsThunk = createAsyncThunk<
  CommonAxiosResponse<GetUserRmaResponse>,
  GetUserRMAPayload,
  { state: RootState }
>("UserAffiliate/getUserRmaDetailsThunk", async (data) => {
  const res = await UserRmaApi.getPcwCareDetails(data);
  const toThunk = thunkResponseHandler(res);
  return toThunk;
});
